import { CommonModule } from '@angular/common';
import { Component, signal, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ThemeService } from './core/services/theme.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CommonModule],
  template: `
  <router-outlet>
  `,
  styleUrl: '../styles.scss'
})
export class App {
  private themeService = inject(ThemeService);
  private translate = inject(TranslateService);
  protected readonly title = signal('transportOps');

  constructor() {
    this.translate.addLangs(['es', 'en', 'fr', 'pt']);
    const savedLang = localStorage.getItem('language') || 'es';
    this.translate.setDefaultLang('es');
    this.translate.use(savedLang);
    (window as any).globalTranslate = this.translate;
  }
}
